let RoleDirective = {
  bind (el, binding, vnode) {
    let admitted = false
    const val = binding.value

    for (var i = 0; i < val.rights.length; i++) {
      for (var j = 0; j < val.user.length; j++) {
        if (val.rights[i] === val.user[j]) {
          admitted = true
          break
        }
      }
    }

    if (!admitted) {
      el.remove()
    }
  }
}

export default RoleDirective



// WEBPACK FOOTER //
// ./src/directives/role.js